import { useEffectOnce } from '@carvana/merch-react-hooks';
import { datadogRum } from '@datadog/browser-rum';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';

export const BACK_FORWARD_CACHE_VIEW_EVENT = 'SRP BFCache View';

export default function useTrackBackForwardCache() {
  const trackEvent = useTrackEvent();

  useEffectOnce(() => {
    if (typeof window === 'undefined') return;

    function handlePageShow(event: PageTransitionEvent) {
      if (!event.persisted) return;
      trackEvent(BACK_FORWARD_CACHE_VIEW_EVENT);
      datadogRum.addAction(BACK_FORWARD_CACHE_VIEW_EVENT);
    }

    window.addEventListener('pageshow', handlePageShow);

    return () => window.removeEventListener('pageshow', handlePageShow);
  }, [trackEvent]);
}
